<template>
  <!-- Modal -->
  <div ref="modalInfo" class="modal it-dialog-scrollable fade" tabindex="-1" role="dialog" id="modal-document-info">
    <div class="modal-dialog modal-dialog-left modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Informazioni sulla pronuncia
              </h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                <svg class="icon">
                    <use :xlink:href="icons.itClose"></use>
                </svg>
              </button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="documentInfo">
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">{{`${documentInfo.type[0].toUpperCase()}${documentInfo.type.slice(1)}`}}</th>
                      <td>{{documentInfo.number}}/{{documentInfo.year}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Ecli</th>
                      <td>{{documentInfo.ecli}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Giudizio</th>
                      <td>{{documentInfo.giudizio}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Presidente</th>
                      <td>{{documentInfo.presidente}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Relatore</th>
                      <td>{{documentInfo.relatore}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Data Decisione</th>
                      <td>{{documentInfo.decisioneDate}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Data Deposito</th>
                      <td>{{documentInfo.depositoDate}}</td>
                    </tr>
                    <tr>
                      <th scope="row">Riferimenti Alle Pronunce Della Corte Costituzionale</th>
                      <td>
                          <ChartGiurisprudenza v-if="aknString" :aknString="aknString" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Riferimenti Alla Legislazione</th>
                      <td>
                          <ChartLegislazione v-if="aknString" :aknString="aknString" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-lg-12 px-lg-12 py-lg-12">
                <h6>
                  Dammi qualche secondo, sto scaricando le informazioni sulla pronuncia!
                </h6>
                <Spinner />
              </div>
            </div>
          </div>
          <div class="modal-footer">
              <button
                class="btn btn-primary btn-sm"
                type="button"
                data-dismiss="modal"
                >Chiudi</button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Spinner from '@/components/layout/accessory/Spinner';
import ChartLegislazione from '@/components/layout/accessory/ChartLegislazione';
import ChartGiurisprudenza from '@/components/layout/accessory/ChartGiurisprudenza';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'modal-document-info',
  props: ['aknString', 'year', 'number'],
  components: {
    Spinner,
    ChartLegislazione,
    ChartGiurisprudenza,
  },
  async mounted() {
    const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
    const url = `${Vue.prototype.$proxy}getDocumentInfo.xq${separator}uri=${this.docUri}&year=${this.year}&number=${this.number}`;
    const documentInfo = await Vue.axios.get(url);
    this.documentInfo = documentInfo.data;
  },
  methods: {
  },
  data() {
    return {
      documentInfo: null,
      icons: {
        itClose: `${sprites}#it-close`,
      },
      chartData: null,
      sunburst: null,
    };
  },
};
</script>

<style>
.echarts {
  position: relative;
  top:-70px!important;
  left:-110px!important;
  width: 620px!important;
  height: 800px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/ModalDocumentInfo.vue